import { motion } from 'framer-motion';
import { useState } from 'react';
import Menu from '../Components/Home/Header/Menu';
import { t } from "i18next"
import ProfileBar from '../Components/Profile/ProfileBar';
import NameHeader from '../Components/Profile/NameHeader';
import Curriculum from '../Components/Profile/Curriculum';


const Profile = () => {

  const [isOpen, setIsOpen] = useState(false)

    return (
        <div className='h-full min-h-screen w-full bg-beige'>
          <motion.div 
          className={`fixed  top-0 left-0 w-full h-1/4 ${isOpen ? 'z-[60]' : 'z-20'}`}
          initial={{ y: -200 }} 
          animate={{ y:  0 }} 
          transition={{ duration: 0.5 }} 
          >
            <ProfileBar isOpen={isOpen} setIsOpen={setIsOpen} />
          </motion.div>
          {
              isOpen && (
                   <Menu isOpen={isOpen} setIsOpen={setIsOpen}  t={t} />
              )
            }
          <section className='h-1/4 w-full flex flex-col justify-center items-start '>
            <NameHeader  />
          </section>
          <section>
            <Curriculum t={t} />
          </section>
        </div>
    )
}

export default Profile